import { Theme } from "../constants";

export const applyTheme = (theme: Theme) => {
  let resolvedTheme = theme;

  // If theme is "system", resolve it to the actual system preference
  if (theme === "system") {
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    resolvedTheme = prefersDark ? "dark" : "light";
  }

  document.documentElement.setAttribute("data-theme", resolvedTheme);
};
